import React from "react";
import { connect } from "react-redux";
import {FormattedMessage} from "react-intl";
import PropTypes from "prop-types";
import { withRouter } from "react-router-dom";

import Button from "@mui/material/Button";

import {
  setLookActiveCategory, setLookOpened,
  setLookOverlayOpened,
  setLookPageOpened, setLookParentKeys,
  setLookStylePopup
} from "../../../actions/lookFunctions";
import {LOOK_OPENED_TYPES, LOOK_OVERLAYS} from "../core/constants";
// import {ROUTES} from "../../../routes";
import WithUpdateLookCartItem from "../hocs/withUpdateLookCartItem";
import {addToCart, changeCartItemQuantity, removeFromCart, updateCanvasCount} from "../../../actions/actionFunctions";
import {setLookRemovedCartItems} from "../../../actions/shoppingCartFunctions";
import {ROUTES} from "../../../routes";
import {getSameColorFeatures} from "../lookNavigation/lookFunctions";
import {disableFeature, featureIsBundle, getFeatureUrl} from "../lookNavigation/lookFunctions2";
import {setShowAddedToTheCartSuccess} from "../../../actions/groheFunctions";
import Analytics, {LOOK_JOURNEY_ANALYTIC_EVENTS} from "../../../analytics";
import {toFixedFeatureCost} from "../../../misc/helpers";
import {getAnalyticsEcommerceItem} from "../../../analyticsEcommerceParams";
// import WithAddToCartPostMessage from "../hocs/withAddToCartPostMessage";


const LookStylePopupButtons = (props) => {

  const {lookActiveFeature, lookOverlayOpened, closePopup, setLookPageOpened, setLookActiveCategory, history,
    lookStylePopup, isMobile, cartItems, removeFromCart, lookRemovedCartItems, setLookRemovedCartItems, addToCart,
    setLookOpened, setLookParentKeys, setLookOverlayOpened, filterGroups, setLookStylePopup, updateCanvasCount,
    setShowAddedToTheCartSuccess, fabricatorSettings} = props;

  const {notMatchingFeatures} = lookStylePopup;

  const submitButtonClick = (type, updateLookCartItem, updateAllLookCartItems) => {
    switch (lookOverlayOpened) {
      case LOOK_OVERLAYS.stylePairing:
      case LOOK_OVERLAYS.styleColor: {

        Analytics.sendClickEvent(LOOK_JOURNEY_ANALYTIC_EVENTS.lookStylePopupConfirm);

        const featureGroup = lookActiveFeature.getParent();
        featureGroup.confirmedChange = true;
        if (type === "all") {
          updateAllLookCartItems(notMatchingFeatures);
          setLookActiveCategory("");
        } else {
          updateLookCartItem(lookActiveFeature)
        }
        // setLookPageOpened("");
        // const urlPartId = lookActiveFeature.partId.replace(/_/gi, "-");
        if (lookOverlayOpened === LOOK_OVERLAYS.stylePairing) {
          const {differentColorFeatures} = getSameColorFeatures(lookActiveFeature, filterGroups) // same color but different feature groups
          if (differentColorFeatures.length) {
            setLookOverlayOpened(LOOK_OVERLAYS.styleColor);
            setLookStylePopup({
              notMatchingFeatures: differentColorFeatures
            });
            break;
          }
        } else { // styleColor
          featureGroup.featureBeforeChange = lookActiveFeature;
        }

        closePopup();
        // addToCartPostMessage(getCartItemsArrayFromFeature(lookActiveFeature, groheActiveFeatureQuantity, qtActiveCategory));
        setShowAddedToTheCartSuccess(true);
        setLookActiveCategory("");
        history.push(getFeatureUrl(lookActiveFeature));
        break;
      }
      default:
        break;
    }
  }

  const removeButtonClick = () => {
    Analytics.sendClickEvent(LOOK_JOURNEY_ANALYTIC_EVENTS.lookStylePopupConfirmRemove);
    let updatedDeletedCartItems = [...lookRemovedCartItems];
    notMatchingFeatures.forEach(feature => {
      const cartItem = cartItems.find((cartItem) => {
        return cartItem.cartFeature && (cartItem.cartFeature.dbFeature.id === feature.dbFeature.id)
      });
      if (cartItem) { // just in case

        Analytics.sendEcommerceEvent("remove_from_cart", {
          currency: fabricatorSettings.currency,
          value: +toFixedFeatureCost(cartItem.cartFeature, cartItem.quantity),
          items: [getAnalyticsEcommerceItem(cartItem.cartFeature, cartItem.quantity)]
        });

        updatedDeletedCartItems.push(cartItem);
        removeFromCart(cartItem);
        if (featureIsBundle(cartItem.cartFeature, cartItems)) {
          cartItems.forEach(cItem => {
            if (cItem.relatedProductParent && cItem.relatedProductParent.dbFeature.id === cartItem.cartFeature.dbFeature.id) {
              updatedDeletedCartItems.push(cItem);
              removeFromCart(cItem);
            }
          })
        }
        let bundleFeature = getBundleFeatureWithoutChildItems(cartItem);
        if (bundleFeature) {
          updatedDeletedCartItems.push(bundleFeature);
          removeFromCart(bundleFeature);
        }
      }
    });
    setLookRemovedCartItems(updatedDeletedCartItems);
    closePopup();
  }

  const getBundleFeatureWithoutChildItems = (cartItem) => {
    let bundleFeatureWithoutChildItems = null;
    if (cartItem.relatedProductParent) {
      let countRelatedProductParent = 0;
      cartItems.forEach(cItem => {
        if (cItem.relatedProductParent && cItem.relatedProductParent.dbFeature.id === cartItem.relatedProductParent.dbFeature.id) {
          countRelatedProductParent++
        }
      })
      if (countRelatedProductParent < 1) {
        bundleFeatureWithoutChildItems = cartItems.find((cItem) => {
          return cItem.cartFeature && (cItem.cartFeature.dbFeature.id === cartItem.relatedProductParent.dbFeature.id)
        });
      }
    }

    return bundleFeatureWithoutChildItems
  }

  const removeBackContinueButtonClick = () => {
    Analytics.sendClickEvent(LOOK_JOURNEY_ANALYTIC_EVENTS.lookStylePopupRemoveBackContinue);
    setLookPageOpened("");
    closePopup();
    history.push(ROUTES.home);
    setLookParentKeys(lookRemovedCartItems.map(cartItem => cartItem.partId));
    setTimeout(() => {
      setLookOpened(LOOK_OPENED_TYPES.edit);
    }, 0)
    // setLookRemovedCartItems([]); // we need to keep them to display in the menu
  }

  const removeBackAddItemsBackClick = () => {
    Analytics.sendClickEvent(LOOK_JOURNEY_ANALYTIC_EVENTS.lookStylePopupRemoveBack);
    addToCart(lookRemovedCartItems);
    setLookRemovedCartItems([]);
    closePopup();
  }

  const removeBothButtonClick = (updateLookCartItem) => {
    setLookPageOpened("");
    closePopup();
    disableFeature(lookActiveFeature, updateLookCartItem);
    updateCanvasCount(); // update canvas and self component
    notMatchingFeatures.forEach(relatedFeature => {
      disableFeature(relatedFeature, updateLookCartItem);
    })
  }

  return (
    <WithUpdateLookCartItem>
      {(updateLookCartItem, updateAllLookCartItems) => (
        <div className="look-popup__buttons">
          {isMobile || (lookOverlayOpened === LOOK_OVERLAYS.styleRemoveBack) ? null : (
            <div className="look-popup__buttons-left">
              <Button className={"look-button look-button--secondary"}
                      onClick={closePopup}>
                <FormattedMessage id="buttons.cancel"/>
              </Button>
            </div>
          )}
          {lookOverlayOpened === LOOK_OVERLAYS.styleRemoveBack ? (
            <div className="look-popup__buttons-left">
              <Button className={"look-button look-button--secondary"}
                      onClick={removeBackAddItemsBackClick}>
                <FormattedMessage id="overlays.style.removeBack.addItemsBack"/>
              </Button>
            </div>
          ) : null}
          {lookOverlayOpened === LOOK_OVERLAYS.styleRemove ? (
            <Button className={"look-button look-button--primary look-button--min" + (isMobile ? " look-button--no-radius" : "")}
                    onClick={removeButtonClick}>
              <FormattedMessage id="buttons.confirm"/>
            </Button>
          ) : null}
          {lookOverlayOpened === LOOK_OVERLAYS.styleRemoveBack ? (
            <Button className={"look-button look-button--primary look-button--min" + (isMobile ? " look-button--no-radius" : "")}
                    onClick={removeBackContinueButtonClick}>
              <FormattedMessage id="buttons.continue"/>
            </Button>
          ) : null}
          {lookOverlayOpened === LOOK_OVERLAYS.stylePairing || lookOverlayOpened === LOOK_OVERLAYS.styleColor ? (
            <div className={"look-popup__buttons-right" + (isMobile ? " text-center" : "")}>
              <Button className={"look-button look-button--secondary" + (isMobile ? " look-button--no-radius" : "")}
                      onClick={() => submitButtonClick("this", updateLookCartItem, updateAllLookCartItems)}>
                <FormattedMessage id="buttons.changeThis"/>
              </Button>
              <Button className={"look-button look-button--primary look-button--min" + (isMobile ? " look-button--no-radius" : "")}
                      onClick={() => submitButtonClick("all", updateLookCartItem, updateAllLookCartItems)}>
                <FormattedMessage id={lookOverlayOpened === LOOK_OVERLAYS.stylePairing ? "buttons.changeBoth" : "buttons.changeAll"}/>
              </Button>
            </div>
          ) : null}
          {lookOverlayOpened === LOOK_OVERLAYS.styleRemoveFeature ? (
            <div className={"look-popup__buttons-right" + (isMobile ? " text-center" : "")}>
              <Button className={"look-button look-button--secondary" + (isMobile ? " look-button--no-radius" : "")}
                      onClick={closePopup}>
                <FormattedMessage id="buttons.keepIt"/>
              </Button>
              <Button className={"look-button look-button--primary look-button--min" + (isMobile ? " look-button--no-radius" : "")}
                      onClick={() => removeBothButtonClick(updateLookCartItem)}>
                <FormattedMessage id="buttons.removeBoth"/>
              </Button>
            </div>
          ) : null}
        </div>
      )}
    </WithUpdateLookCartItem>
  )
};

LookStylePopupButtons.propTypes = {
  closePopup: PropTypes.func.isRequired
}

const mapStateToProps = (store) => {
  const {lookOverlayOpened, lookStylePopup, lookActiveFeature} = store.lookState;
  const {isMobile} = store.serverState;
  const {cartItems, lookRemovedCartItems} = store.cartState;
  const {filterGroups} = store.filterState;
  // const {groheActiveFeatureQuantity} = store.groheState;
  // const {qtActiveCategory} = store.qtState;
  const {settings} = store.fabricatorState;

  return {
    lookOverlayOpened,
    lookStylePopup,
    lookActiveFeature,
    isMobile,
    cartItems,
    lookRemovedCartItems,
    filterGroups,
    fabricatorSettings: settings,
    // groheActiveFeatureQuantity,
    // qtActiveCategory,
  };
};

const mapDispatchToProps = {
  setLookOverlayOpened,
  setLookStylePopup,
  setLookActiveCategory,
  setLookPageOpened,
  removeFromCart,
  setLookRemovedCartItems,
  addToCart,
  setLookOpened,
  setLookParentKeys,
  updateCanvasCount,
  changeCartItemQuantity,
  setShowAddedToTheCartSuccess,
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(LookStylePopupButtons)
)
